import React from "react";

import { Link } from "react-router-dom";
import styled from "styled-components/macro";

import { baseButtonStyles } from "../../styles/sharedStyles";

type TLinkWrapper = {
  $isBlack?: boolean,
  $hasBorder?: boolean,
}

const LinkWrapper = styled(Link)<TLinkWrapper>`
 ${baseButtonStyles};
  border-color: ${({ $hasBorder }) => $hasBorder ? "#141414" : "#fff"};
`

type TButtonLink = {
  toPage: string,
  title: string,
  hasBorder?: boolean,
  isBlack?: boolean,
}

export const ButtonLink: React.FC<TButtonLink> = ({
  toPage,
  title,
  hasBorder = true,
  isBlack = false,
}) => {
  return (
    <LinkWrapper
      $hasBorder={hasBorder}
      $isBlack={isBlack}
      to={toPage}
    >
      {title}
    </LinkWrapper>
  )
}

